// Common translations for Supplier Portal
export const supplierTranslations = {
  // Status labels
  status: {
    completed: { de: 'Abgeschlossen', en: 'Completed' },
    inProgress: { de: 'In Bearbeitung', en: 'In Progress' },
    pending: { de: 'Ausstehend', en: 'Pending' },
    overdue: { de: 'Überfällig', en: 'Overdue' },
    draft: { de: 'Entwurf', en: 'Draft' },
    approved: { de: 'Genehmigt', en: 'Approved' },
    submitted: { de: 'Eingereicht', en: 'Submitted' },
    requested: { de: 'Angefordert', en: 'Requested' },
    needsCorrection: { de: 'Korrektur erforderlich', en: 'Needs Correction' },
    rejected: { de: 'Abgelehnt', en: 'Rejected' },
  },

  // Common UI elements
  ui: {
    search: { de: 'Suchen...', en: 'Search...' },
    searchQuestionnaires: { de: 'Fragebögen durchsuchen...', en: 'Search questionnaires...' },
    searchArticles: { de: 'Artikel suchen (Name, Art.-Nr., Ext. Art.-Nr., GTIN, Brand)...', en: 'Search articles (Name, Art. No., Ext. Art. No., GTIN, Brand)...' },
    allStatuses: { de: 'Alle Status', en: 'All Statuses' },
    allTypes: { de: 'Alle Typen', en: 'All Types' },
    total: { de: 'Gesamt', en: 'Total' },
    show: { de: 'Anzeigen', en: 'Show' },
    edit: { de: 'Bearbeiten', en: 'Edit' },
    view: { de: 'Ansehen', en: 'View' },
    create: { de: 'Erstellen', en: 'Create' },
    save: { de: 'Speichern', en: 'Save' },
    cancel: { de: 'Abbrechen', en: 'Cancel' },
    delete: { de: 'Löschen', en: 'Delete' },
    close: { de: 'Schließen', en: 'Close' },
  },

  // Entities
  entities: {
    questionnaire: { de: 'Fragebogen', en: 'Questionnaire' },
    questionnaires: { de: 'Fragebögen', en: 'Questionnaires' },
    article: { de: 'Artikel', en: 'Article' },
    articles: { de: 'Artikel', en: 'Articles' },
    auction: { de: 'Auktion', en: 'Auction' },
    auctions: { de: 'Auktionen', en: 'Auctions' },
    supplier: { de: 'Lieferant', en: 'Supplier' },
  },

  // Common phrases
  common: {
    yourQuestionnaires: { de: 'Ihre Fragebögen', en: 'Your Questionnaires' },
    daysRemaining: { de: 'Tage verbleibend', en: 'days remaining' },
    completed: { de: 'abgeschlossen', en: 'completed' },
    completedOn: { de: 'Abgeschlossen am', en: 'Completed on' },
    requestedOn: { de: 'Angefordert am', en: 'Requested on' },
    completeness: { de: 'Vollständigkeit', en: 'Completeness' },
    actions: { de: 'Aktionen', en: 'Actions' },
    externalArtNo: { de: 'Externe Art.-Nr.', en: 'External Art. No.' },
    name: { de: 'Name', en: 'Name' },
    brand: { de: 'Brand', en: 'Brand' },
  },

  // Article specific
  articles: {
    createArticle: { de: 'Artikel erstellen', en: 'Create Article' },
    requestedArticles: { de: 'Angeforderte Artikel', en: 'Requested Articles' },
    draftArticles: { de: 'Entwurf Artikel', en: 'Draft Articles' },
  },

  // Questionnaire types
  questionnaireTypes: {
    producer: { de: 'Produzent', en: 'Producer' },
    trader: { de: 'Händler', en: 'Trader' },
    trader_producer: { de: 'Händler & Produzent', en: 'Trader & Producer' },
    non_food: { de: 'Non-Food', en: 'Non-Food' },
    gmo_declaration: { de: 'GVO-Erklärung', en: 'GMO Declaration' },
    conformity_declaration: { de: 'Konformitätserklärung', en: 'Conformity Declaration' },
    emergency_contact: { de: 'Notfallkontakt', en: 'Emergency Contact' },
    unknown: { de: 'Unbekannt', en: 'Unknown' },
  },

  // Messages
  messages: {
    loading: { de: 'Laden...', en: 'Loading...' },
    loadingQuestionnaires: { de: 'Fragebögen werden geladen...', en: 'Loading questionnaires...' },
    errorLoadingQuestionnaires: { de: 'Fragebögen konnten nicht geladen werden', en: 'Failed to load questionnaires' },
    noQuestionnairesFound: { de: 'Keine Fragebögen gefunden, die Ihren Filterkriterien entsprechen', en: 'No questionnaires found matching your filter criteria' },
    noQuestionnairesAvailable: { de: 'Keine Fragebögen verfügbar', en: 'No questionnaires available' },
    resetFilters: { de: 'Filter zurücksetzen', en: 'Reset filters' },
    questionnaireNotAvailable: { de: 'Dieser Fragebogen ist nicht verfügbar.', en: 'This questionnaire is not available.' },
    noValidSession: { de: 'Keine gültige Session gefunden. Bitte melden Sie sich erneut an.', en: 'No valid session found. Please log in again.' },
    unknownQuestionnaire: { de: 'Unbekannter Fragebogen', en: 'Unknown Questionnaire' },
  },
};

// Helper function to get nested translation
export const getTranslation = (path: string, t: (text: { de: string; en: string }) => string): string => {
  const keys = path.split('.');
  let value: any = supplierTranslations;
  
  for (const key of keys) {
    value = value[key];
    if (!value) return path; // Return path if not found
  }
  
  return t(value);
};
